export default "__VITE_ASSET__7de4d9e8__"